import { render, staticRenderFns } from "./tasksConfiguration.vue?vue&type=template&id=22b0c0f6&"
import script from "./tasksConfiguration.vue?vue&type=script&lang=js&"
export * from "./tasksConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports